export default __webpack_public_path__ + "static/media/august2023-5.490e4d20.jpg";